import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const DeleteApiKeyDialog = ({ open, onClose, onConfirm, apiKeyToDelete }) => {
    return (
        <Dialog open={open} onClose={onClose} data-test-id="delete-api-key-dialog">
            <DialogTitle>Deactivate API Key</DialogTitle>
            <DialogContent>
            <Typography>
                Are you sure you want to deactivate the API key "{apiKeyToDelete?.name}"? 
                The key will be deactivated but can be restored later. Usage data will be preserved.
            </Typography>
            </DialogContent>
            <DialogActions>
            <Button onClick={onClose} data-test-id="delete-api-key-cancel">Cancel</Button>
            <Button
                onClick={onConfirm}
                color="warning"
                variant="contained"
                data-test-id="delete-api-key-confirm"
            >
                Deactivate
            </Button>
            </DialogActions>
      </Dialog>
    );
}

export default DeleteApiKeyDialog;
